import * as React from "react"
import { Line } from "react-chartjs-2"
import { injectIntl, InjectedIntlProps } from "react-intl"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { CardModalNotOkButton } from "../../modal"
import { LocalAuthority, Loan, Scenario, Ppi, Service } from "../../../model"

import "./style.scss"
import { PolitiqueModalErrors } from "../local-authority-detail/politique-modal"
import { AddWordErrors } from "../local-authority-detail/add-word-modal"
import GoalsCard from "../local-authority-detail/goals-card"
import { AddDemographyErrors } from "../local-authority-detail/add-demography-modal"


class LocalAuthorityDashbordComponent
extends React.Component<LocalAuthorityDashbordComponentProps & InjectedIntlProps, LocalAuthorityDashbordComponentState> {
	years: number[]; 

	constructor(props) {
        super(props);		
        this.state = {
            consulted: null,
            dataFonctExpense: [],
            dataFonctReceipts: [],
            dataInvestExpense: [],
            dataInvestReceipts: [],
            dataResult: [],
            displayCharts: false,
            loading: true,
            tableCafBData: [],
            tableCafNData: [],
            tableResData: [],
            tableResYears: [],
        };
    }

	private renderLoading(key: React.ReactText): React.ReactNode {
		return <div className="bloc-center">
			<FontAwesomeIcon icon="spinner" pulse />
		</div>
	}

	renderInformation(){
		if (this.props.isLoadingInformation) return this.renderLoading(`loading`);
		return this.props.information;
	}

	
	render() {
		const loans = this.props.loans
		const localAuthority = this.props.localAuthority 
		const scenarii = this.props.scenarii
		const ppi = this.props.ppi
		const currentYear = this.props.currentYear
		const loadingGoalsCard = this.props.loadingLoans
		|| this.props.loadingLocalAuthority
		|| this.props.loadingPpi
		|| this.props.loadingScenarii
		const currentUser = this.props.currentUser ? this.props.currentUser : "";    

		const chart1 = {
			labels: this.props.chartData.labels || [],
			datasets: (this.props.chartData.datasets || []).filter(dataset =>
			  dataset.label === "Recettes réelles" || dataset.label === "Dépenses réelles"
			)
		  };
		const chart2 = {
			labels: this.props.chartData.labels || [],
			datasets: (this.props.chartData.datasets || []).filter(dataset =>
				dataset.label === "CAF brute" || dataset.label === "Remboursement des emprunts" || dataset.label === "CAF nette"
			)
		};


		const chartOptions = {
			responsive: true,
			maintainAspectRatio: false,
			scales: {
				xAxes: [
					{
					  gridLines: {
						display: false
					  },
					  offset: true
					}
				  ],
			  yAxes: [
				{
				  ticks: {
					callback: (value, index, values) =>
					  this.props.intl.formatNumber(value, {
						currency: "EUR",
						style: "currency",
					  }),
				  },
				},
			  ],
			},
			tooltips: {
			  callbacks: {
				label: (tooltip, data) => {
				  const datasetIndex = tooltip.datasetIndex;
				  const dataIndex = tooltip.index;
				  const value = data.datasets[datasetIndex].data[dataIndex];
				  const formattedValue = this.props.intl.formatNumber(value, {
					currency: "EUR",
					style: "currency",
				  });
				  return `${data.labels[dataIndex]} : ${formattedValue}`;
				},
			  },
			},
		  };
		
		return <div className="section">
			<div className="grid-container">
				<div className="block-card block1">
					<h2 className="card-header-title card-title-dashboard">⚖ Information réglementaire</h2>
					<div className="card-custom card-custom_ofy">
						{this.renderInformation()}
					</div>
				</div>
				<div className="block-card block2">
					<h2 className="card-header-title card-title-dashboard">📈 Constat rétrospectif de fonctionnement</h2>
					<div className="card-custom card-custom_chart">
						<Line data={chart1} options={chartOptions} />
					</div>
				</div>
				<div className="block-card block3">
					<h2 className="card-header-title card-title-dashboard">📉 Récap de fonctionnement</h2>
					<div className="card-custom card-custom_chart">
						<Line data={chart2} options={chartOptions} />
					</div>
				</div>

				<div className="sidebar">
					<h2 className="card-header-title card-title-dashboard">🆕 Dernières informations</h2>
					<a href="https://fr.linkedin.com/company/sfp-collectivit%C3%A9s" target="_blank" className="card-custom">
						<img className="logo-sfp" src="/images/logo-sfp.jpg" alt="Logo SFP Collectivités" width={70} />
						<strong>SFP Collectivités</strong>
						<img className="logo-linkedIn" src="/images/logo-linkedin.svg" alt="Compte LinkedIn SFP Collectivités" width={40} />
					</a>
					<a href="https://www.youtube.com/@sfpcollectivites697" target="_blank" className="card-custom">
						<img className="logo-sfp" src="/images/logo-sfp.jpg" alt="Logo SFP Collectivités" width={70} />
						<strong>SFP Collectivités</strong>
						<img className="logo-linkedIn" src="/images/logo-youtube.svg" alt="Compte Youtube SFP Collectivités" width={40} />
					</a>
					<a href="https://data.ofgl.fr/pages/accueil/" target="_blank" className="card-custom">
						<img className="" src="/images/logo-observatoire-des-finances.png" alt="Logo SFP Collectivités" width={70} />
						<strong>Portail des données financières et de gestion du secteur public local</strong>
					</a>
					<a href="https://www.impots.gouv.fr/cll/zf1/accueil/flux.ex?_flowId=accueilcclloc-flow" target="_blank" className="card-custom">
						<img className="" src="/images/rf.webp" alt="Logo République Française" width={70} />
						<strong>Les comptes des collectivités</strong>
					</a>
					<a href="https://sfp-collectivites.fr/sfp-learning_videos/" target="_blank" className="card-custom">
						<img className="logo-sfp" src="/images/logo-sfp.jpg" alt="Logo SFP Collectivités" width={70} />
						<strong>Vidéos des webinaires</strong>
					</a>
				</div>

				<div className="block-chiffres-cles">
					<GoalsCard
					loading={loadingGoalsCard}
					loans={loans}
					localAuthority={localAuthority}
					scenarii={scenarii}
					ppi={ppi}
					year={currentYear} />
				</div>

			</div>
		</div>
	}

}



export default injectIntl(LocalAuthorityDashbordComponent)

export interface LocalAuthorityDashbordComponentProps {
	isLoadingInformation: boolean
	chartData: any
	information: string
	addWordErrors: AddWordErrors
	PolitiqueErrors:PolitiqueModalErrors
	consulted: boolean
	showViewPolitique: boolean
	currentYear: number
	demographyData: Chart.ChartData
	loans: Loan[]
	loadingLoans: boolean
	loadingLocalAuthority: boolean
	loadingPpi: boolean
	loadingScenarii: boolean
	loadingServices: boolean
	localAuthority: LocalAuthority
	ppi: Ppi
	scenarii: Scenario[]
	services: Service[]
	showAddDemographyModal: boolean
	showAddWord: boolean
	showViewDemographiesModal: boolean
	showViewGlossary: boolean
	addDemographyErrors?: AddDemographyErrors
	addingDemography?: boolean
	addingWord?: boolean
	PolitiqueChanges:boolean
	currentUser: any

	onClickAddDemography(event: React.SyntheticEvent<Element>): void
	onClickAddDemographyModalCloseButton(event: React.SyntheticEvent<Element>): void
	onClickAddDemographyModalFooterButton(button: CardModalNotOkButton, event: React.SyntheticEvent<Element>): void
	onClickAddWord(event: React.SyntheticEvent<Element>): void
	onClickAddWordCloseButton(event: React.SyntheticEvent<Element>): void
	onClickPolitiqueModalButton(event: React.SyntheticEvent<Element>): void
	onClickPolitiqueModalFooterButton(button: CardModalNotOkButton ,event: React.SyntheticEvent<Element>): void
	onClickAddWordFooterButton(button: CardModalNotOkButton ,event: React.SyntheticEvent<Element>): void
	onClickViewDemographies(event: React.SyntheticEvent<Element>): void
	onClickViewDemographyModalCloseButton(event: React.SyntheticEvent<Element>): void
	onClickViewDemographyModalFooterButton(button: CardModalNotOkButton, event: React.SyntheticEvent<Element>): void
	onClickViewGlossary(event: React.SyntheticEvent<Element>): void
	onClickPolitiqueChanges(event: React.SyntheticEvent<Element>): void
	onClickViewGlossaryCloseButton(event: React.SyntheticEvent<Element>): void
	onClickViewApprocheCloseButton(event: React.SyntheticEvent<Element>): void
	onClickViewGlossaryFooterButton(button: CardModalNotOkButton ,event: React.SyntheticEvent<Element>): void
	onClickViewApprocheFooterButton(button: CardModalNotOkButton ,event: React.SyntheticEvent<Element>): void
	onSubmitAddDemographyModal(event: React.SyntheticEvent<Element>): void
	onSubmitAddWord(event: React.SyntheticEvent<Element>): void
	onSubmitPolitiqueModal(event: React.SyntheticEvent<Element>): void
	onSubmitEditWord(event: React.SyntheticEvent<Element>): void
	onClickViewPolitique(event: React.SyntheticEvent<Element>): void
	onClickViewPolitiqueClose(event: React.SyntheticEvent<Element>): void
}

interface LocalAuthorityDashbordComponentState {
    consulted: any;
    dataFonctExpense: any[];
    dataFonctReceipts: any[];
    dataInvestExpense: any[];
    dataInvestReceipts: any[];
    dataResult: any[];
    displayCharts: boolean;
    loading: boolean;
    tableCafBData: any[];
    tableCafNData: any[];
    tableResData: any[];
    tableResYears: any[];
}



// WEBPACK FOOTER //
// ./src/component/local-authority/local-authority-dashbord/local-authority-dashbord-component.tsx